module.exports = __webpack_public_path__ + "img/uk-market-banner.f1c1e796.png";